import React, {useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'


export default function AutoComplete(props) {
  const {objKey, className, options, defaultValue, setValue, disableSearch, name, required, readOnly, onSearch } = props

  const { t } = useTranslation()
  
  const [display, setDisplay] = useState(false)
  const [search, setSearch] = useState('')
  const [searchChanged, setSearchChanged] = useState(false)
  const [defValue, setDefValue] = useState(defaultValue)
  // for clicking outside options to close
  const wrapperRef = useRef(null)
  const initVals = useRef(false)

  const srchPlaceholder = (disableSearch) ? '' : t('search')+'..'

  const handleClickOutside = event => {
    const { current: wrap } = wrapperRef
    if (wrap && !wrap.contains(event.target)) {
      setDisplay(false)
    }
  }

  const updateSearch = srch => {
    setSearch(srch.name ? srch.name:'')
    if(!options && !onSearch) return
    
    if(onSearch) {
      onSearch(srch.name ? srch.name:'')
    }
    
    let newVal = name ? name : srch.id
    setValue(newVal, objKey)
    setDisplay(false)
  }

  function clickHandler(evt) {
    setDisplay(false)
    setSearch('')
    setSearchChanged(true)
    let newVal = name ? name : ''
    setValue(newVal, objKey)
  }

  const setDefaultValue = () => {
    if(options && options.length){
      let name = options.find(item => item.id == defaultValue)
      setDefValue(name ? name.name : '')
    }
  }

  useEffect(() => {
    if(defaultValue && !initVals.current) {
      setDefaultValue()
      initVals.current = true
    }
  }, [defaultValue])

   useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    }
  }, [])


  return (
    <div ref={wrapperRef} className="auto-container">
      <input
        id="autoInput"
        name={name}
        className={className}
        autoComplete="off"
        onClick={() => {
          if(readOnly) return

          setDisplay(!display); 
          setSearchChanged(true); 
          setSearch('');}}
        placeholder={srchPlaceholder}
        value={(!defaultValue || searchChanged) ? search : defValue}
        required={required || false}
        readOnly={readOnly || false}
        onChange={event => {
          updateSearch({id: '', name: event.target.value}); 
          setDisplay(true); 
          setSearchChanged(true);
        }}
      />
      
      {display && (
        <div className="autocomplete-list">
          {options && options
            .filter((option) => option.name.toLowerCase().indexOf(search.toLowerCase()) > -1)
            .map((value, i) => {
              return (
                <div
                onClick={() => updateSearch({id: value.id, name: value.name})}
                className="autocomplete-option"
                key={i}
                tabIndex="0"
                >
                  <span>{value.name}</span>
                </div>
              );
            })}
        </div>
      )}
      <span className="bt-clear" onClick={event => clickHandler(event)} hidden={readOnly ? true : false}>X</span>
    </div>
  )
}
